// extracted by mini-css-extract-plugin
export default {"container":"JoinUs_container__buxY+","info":"JoinUs_info__h8Thb","icon":"JoinUs_icon__LGcpa","title":"JoinUs_title__NGzjT","contactButton":"JoinUs_contactButton__P7tmV"};